import { render, staticRenderFns } from "./DatesLockForm.vue?vue&type=template&id=f222fb8a&scoped=true&"
import script from "./DatesLockForm.vue?vue&type=script&lang=js&"
export * from "./DatesLockForm.vue?vue&type=script&lang=js&"
import style0 from "./DatesLockForm.vue?vue&type=style&index=0&id=f222fb8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f222fb8a",
  null
  
)

export default component.exports